/* JONI'S — Custom Cart Drawer v2.1
   Upsell: manage via Shopify collection 'cart-upsells'
   Greeting: saved as cart attribute 'ברכה כתובה'

   v2.0 — NO HARD-CODED COPY. Every string comes from the theme editor.
   v2.1 — THEME EDITOR SUPPORT. Three problems this fixes:
     1. The editor replaces the whole section's DOM on every setting change. init() used to
        run once and stayed bound to the OLD nodes, so the fresh drawer had no listeners at
        all — dead until Save + reload.
     2. Config used to arrive in an inline <script>. Scripts introduced by a DOM swap do not
        execute again, so the JS kept rendering the values from the original page load.
        Config is now read out of a <script type="application/json"> block in the DOM on
        every (re)init, so live edits appear immediately.
     3. The drawer is closed by default, so editing its texts showed nothing. In design mode
        it now opens when the section is selected and re-opens after each re-render.

   Carried over from v1.3: shop-accurate money formatting, free-shipping gap closer,
   honest discount handling (no fake success, no formaction override).
*/
(function () {
  'use strict';

  /* the section's <script src> may be re-injected by a re-render; keep one instance */
  if (window.jonisCartDrawerBoot) return;

  var THRESHOLD    = 20000;
  var MONEY_FORMAT = '{{amount_no_decimals}} ₪';
  var UPSELL_HANDLE = 'cart-upsells';
  var UPSELL_LIMIT  = 5;
  var GREETING_KEY  = 'ברכה כתובה';
  var GIFT_ORDER_KEY = 'הזמנה למתנה';

  var T = {
    shipProgress:     'עוד [סכום] למשלוח חינם',
    shipSuccess:      'המשלוח החינם נפתח',
    shipSuccessNote:  'המשלוח עלינו — אפשר להמשיך לתשלום',
    shipSuggest:      'הוסיפו [מוצר] · [מחיר] והמשלוח עלינו',
    upsellAdd:        'הוסף לעגלה',
    upsellAdded:      'נוסף לעגלה',
    upsellSoldout:    'אזל המלאי',
    upsellMore:       'פרטים נוספים',
    kishoritBadge:    'עבודת יד · כישורית',
    matchesBadge:     'מתאים לנר',
    kishoritOrigin:   'נוצר בעבודת יד בקהילה המשלבת של כישורית בגליל.',
    matchesOrigin:    'נבחר כהשלמה טבעית לנר.',
    discountChecking: 'בודק את הקוד…',
    discountSuccess:  'הקוד הוחל · הסכום עודכן',
    discountPending:  'הקוד נשמר ויאומת בעמוד התשלום',
    addError:         'לא הצלחנו להוסיף את הפריט. נסו שוב בעוד רגע'
  };

  var drawer, overlay, itemsEl, emptyEl, footerEl, controlsEl, totalEl, shippingBar, shippingFill, shippingText, upsellSection, upsellTrack, suggestBtn, suggestText;
  var isOpen = false, isCartPage = false, globalsBound = false, cartState = null;
  var noteTimer = null, greetingTimer = null;
  var fieldsQueue = Promise.resolve();
  var upsellProducts = [];
  var greetingMax = 200;
  var lastFocusedElement = null;
  var extrasRevision = 0, pendingView = false;

  function isDesignMode() { return !!(window.Shopify && window.Shopify.designMode); }

  /* ─ Config ─
     Read from the DOM, never from a global set by an inline script: the editor's section
     re-render swaps HTML in without executing its <script> tags, so a global would go stale. */
  function readConfig() {
    var el = document.getElementById('jonis-cart-config');
    if (el) {
      try {
        var cfg = JSON.parse(el.textContent);
        if (cfg.freeShippingThreshold) THRESHOLD = cfg.freeShippingThreshold;
        if (cfg.moneyFormat) MONEY_FORMAT = cfg.moneyFormat;
        if (cfg.upsellCollection) UPSELL_HANDLE = cfg.upsellCollection;
        if (cfg.text) {
          for (var k in cfg.text) {
            if (Object.prototype.hasOwnProperty.call(cfg.text, k) && cfg.text[k]) T[k] = cfg.text[k];
          }
        }
        return;
      } catch (e) { console.error('jonis cart config parse failed', e); }
    }
    /* fallback for anything still setting the old globals */
    if (window.jonisCartSettings && window.jonisCartSettings.freeShippingThreshold) {
      THRESHOLD = window.jonisCartSettings.freeShippingThreshold;
    }
    if (window.jonisMoneyFormat) MONEY_FORMAT = window.jonisMoneyFormat;
  }

  /* ─ Money ─
     Mirrors Shopify's own money filter so Liquid-rendered and JS-rendered prices are
     byte-identical. This shop's format is '{{amount_no_decimals}} ₪' — shekel AFTER the
     number. Hard-coding '₪' + n put it before, so the price appeared to change the moment
     the shopper touched the quantity. */
  function formatWithDelimiters(cents, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal   = decimal   || '.';
    if (isNaN(cents) || cents === null) return '0';
    var num   = (cents / 100.0).toFixed(precision);
    var parts = num.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function fmt(cents) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = MONEY_FORMAT.match(placeholder);
    var key   = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount':                                   value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals':                       value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator':              value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':  value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator':              value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator':  value = formatWithDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_period_and_space_separator':   value = formatWithDelimiters(cents, 2, ' ', '.'); break;
      default:                                         value = formatWithDelimiters(cents, 2);
    }
    return MONEY_FORMAT.replace(placeholder, value);
  }

  function esc(s) {
    return s ? String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;') : '';
  }
  /* split/join, not replace() — replace() with a string only swaps the first match,
     and an editor-authored template may legitimately repeat a placeholder. */
  function fill(tpl, token, value) { return String(tpl).split(token).join(value); }

  /* ─ Init ─ re-runnable. Called on load and again after every editor section re-render. */
  function init() {
    readConfig();

    drawer  = document.getElementById('jonis-cart-drawer');
    overlay = document.getElementById('jonis-cart-overlay');
    if (!drawer || !overlay) return;
    isCartPage = drawer.dataset.cartPage === 'true';

    itemsEl       = document.getElementById('jonis-cart-items');
    emptyEl       = document.getElementById('jonis-cart-empty');
    footerEl      = document.getElementById('jonis-cart-footer');
    controlsEl    = document.getElementById('jonis-cart-controls');
    totalEl       = document.getElementById('jonis-cart-total');
    shippingBar   = document.getElementById('jonis-shipping-bar');
    shippingFill  = document.getElementById('jonis-shipping-fill');
    shippingText  = document.getElementById('jonis-shipping-text');
    upsellSection = document.getElementById('jonis-cart-upsell');
    upsellTrack   = document.getElementById('jonis-upsell-track');
    suggestBtn    = document.getElementById('jonis-shipping-suggest');
    suggestText   = document.getElementById('jonis-shipping-suggest-text');

    /* ─ bindings on the drawer's own (freshly rendered) nodes ─ */
    var closeBtn = document.getElementById('jonis-cart-close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    var contBtn = document.getElementById('jonis-continue-btn');
    if (contBtn) contBtn.addEventListener('click', closeDrawer);

    if (suggestBtn) suggestBtn.addEventListener('click', addSuggested);

    initToggle('jonis-note-toggle','jonis-note-body');
    var noteTA = document.getElementById('jonis-cart-note');
    if (noteTA) {
      noteTA.addEventListener('input', function(){
        noteTA.dataset.prefilled = '1';
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function(){ saveNote(noteTA.value); }, 900);
      });
    }

    initToggle('jonis-greeting-toggle','jonis-greeting-body');
    initGreeting();
    initGiftOrder();

    initToggle('jonis-discount-toggle','jonis-discount-body');
    var dBtn   = document.getElementById('jonis-discount-btn');
    var dInput = document.getElementById('jonis-discount-input');
    if (dBtn) dBtn.addEventListener('click', applyDiscount);
    if (dInput) dInput.addEventListener('keydown', function(e){
      if (e.key === 'Enter') { e.preventDefault(); applyDiscount(); }
    });

    bindUpsellControls();

    /* open triggers live in the header, outside the section — bind each element once */
    document.querySelectorAll('[data-open-cart-drawer]').forEach(function(el){
      if (el.dataset.jonisCartBound) return;
      el.dataset.jonisCartBound = '1';
      el.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); });
    });

    /* ─ document-level listeners: exactly once, they survive section re-renders ─ */
    if (!globalsBound) {
      globalsBound = true;
      document.addEventListener('keydown', function(e){
        if (!isOpen || isCartPage) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          closeDrawer();
          return;
        }
        if (e.key !== 'Tab') return;
        var focusable = Array.from(drawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function(el){ return !el.hidden && el.getAttribute('aria-hidden') !== 'true'; });
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
      document.addEventListener('cart:updated', function(){ if(isOpen) refreshCart(); });
      bindForms(document);
      new MutationObserver(function(muts){
        muts.forEach(function(m){
          m.addedNodes.forEach(function(n){ if(n.nodeType===1&&n.querySelectorAll) bindForms(n); });
        });
      }).observe(document.body,{childList:true,subtree:true});
      bindEditorEvents();
    }
    if (isCartPage) {
      isOpen = true;
      pendingView = true;
      refreshCart();
      loadUpsells();
    }
  }

  /* ─ Theme editor ─
     shopify:section:load fires after the editor swaps this section's HTML in. Re-init against
     the new nodes and put the drawer back on screen so the merchant can actually see the
     text they just edited. */
  function bindEditorEvents() {
    if (!isDesignMode()) return;

    function isOurs(el) {
      return el && el.querySelector && el.querySelector('#jonis-cart-drawer');
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (!isOurs(e.target)) return;
      isOpen = false;
      init();
      openDrawer();
    });

    document.addEventListener('shopify:section:select', function (e) {
      if (!isOurs(e.target)) return;
      openDrawer();
    });

    document.addEventListener('shopify:section:deselect', function (e) {
      if (!isOurs(e.target)) return;
      closeDrawer();
    });
  }

  function initToggle(toggleId, bodyId) {
    var tog  = document.getElementById(toggleId);
    var body = document.getElementById(bodyId);
    if (!tog || !body) return;
    tog.addEventListener('click', function(){
      var exp = tog.getAttribute('aria-expanded')==='true';
      tog.setAttribute('aria-expanded', String(!exp));
      body.style.display = exp ? 'none' : 'block';
    });
  }

  function openGreetingPanel(focusTextarea) {
    var tog  = document.getElementById('jonis-greeting-toggle');
    var body = document.getElementById('jonis-greeting-body');
    var ta   = document.getElementById('jonis-greeting-text');
    if (!tog || !body) return;
    tog.setAttribute('aria-expanded', 'true');
    body.style.display = 'block';
    if (focusTextarea && ta) ta.focus();
  }

  /* ─ Greeting ─ */
  function initGreeting() {
    var ta      = document.getElementById('jonis-greeting-text');
    var counter = document.getElementById('jonis-greeting-count');
    var saved   = document.getElementById('jonis-greeting-saved');
    if (!ta) return;

    var ctrWrap = counter && counter.closest('.jonis-cart-drawer__greeting-counter');
    if (ctrWrap && ctrWrap.dataset.max) greetingMax = parseInt(ctrWrap.dataset.max, 10) || 200;

    ta.addEventListener('input', function(){
      ta.dataset.prefilled = '1';
      var len = ta.value.length;
      if (counter) {
        counter.textContent = len;
        if (ctrWrap) ctrWrap.classList.toggle('near-limit', len >= greetingMax - 20);
      }
      clearTimeout(greetingTimer);
      greetingTimer = setTimeout(function(){ saveGreeting(ta.value, saved); }, 800);
    });
  }

  function prefillGreeting(attributes) {
    var ta = document.getElementById('jonis-greeting-text');
    var counter = document.getElementById('jonis-greeting-count');
    if (!ta || ta.dataset.prefilled) return;
    var val = cartAttributeValue(attributes, GREETING_KEY);
    if (val) {
      ta.value = val;
      if (counter) counter.textContent = val.length;
      ta.dataset.prefilled = '1';
      openGreetingPanel(false);
    }
  }

  function cartAttributeValue(attributes, key) {
    if (!attributes) return '';
    if (Array.isArray(attributes)) {
      for (var i = 0; i < attributes.length; i++) {
        if (attributes[i].key === key) return attributes[i].value || '';
      }
      return '';
    }
    return attributes[key] || '';
  }

  function initGiftOrder() {
    var cb = document.getElementById('jonis-gift-order-checkbox');
    if (!cb || cb.dataset.bound === '1') return;
    cb.dataset.bound = '1';
    if (cb.checked) openGreetingPanel(false);
    cb.addEventListener('change', function(){
      if (cb.checked) openGreetingPanel(true);
      saveGiftOrder(cb.checked);
    });
  }

  function prefillGiftOrder(attributes) {
    var cb = document.getElementById('jonis-gift-order-checkbox');
    var help = document.getElementById('jonis-gift-order-help');
    if (!cb) return;
    var checked = cartAttributeValue(attributes, GIFT_ORDER_KEY) === 'כן';
    cb.checked = checked;
    if (help) help.hidden = !checked;
    if (checked) openGreetingPanel(false);
  }

  function saveGiftOrder(checked) {
    var cb = document.getElementById('jonis-gift-order-checkbox');
    var help = document.getElementById('jonis-gift-order-help');
    var status = document.getElementById('jonis-gift-order-status');
    var wrapper = document.getElementById('jonis-gift-order');
    var checkoutBtn = document.getElementById('jonis-checkout-btn');
    if (help) help.hidden = !checked;
    if (status) status.textContent = '';
    if (cb) cb.disabled = true;
    if (checkoutBtn) checkoutBtn.disabled = true;
    saveCartFields()
      .then(function(cart){
        cartState = cart;
        prefillGiftOrder(cart.attributes);
      })
      .catch(function(error){
        console.error(error);
        if (cb) cb.checked = !checked;
        if (help) help.hidden = checked;
        if (status) status.textContent = wrapper ? wrapper.dataset.error : '';
      })
      .finally(function(){
        if (cb) cb.disabled = false;
        if (checkoutBtn) checkoutBtn.disabled = false;
      });
  }

  function saveGreeting(text, savedEl) {
    saveCartFields().then(function(){
      if (savedEl) {
        savedEl.classList.add('visible');
        setTimeout(function(){ savedEl.classList.remove('visible'); }, 2000);
      }
    }).catch(function(error){
      if (savedEl) savedEl.classList.remove('visible');
      console.error(error);
    });
  }

  // Serialize field saves and send one current snapshot so simultaneous edits
  // to the greeting, gift flag and note cannot overwrite each other.
  function saveCartFields() {
    fieldsQueue = fieldsQueue.catch(function(){}).then(function(){
      var greeting = document.getElementById('jonis-greeting-text');
      var gift = document.getElementById('jonis-gift-order-checkbox');
      var note = document.getElementById('jonis-cart-note');
      var payload = { attributes: {} };
      if (greeting) payload.attributes[GREETING_KEY] = greeting.value;
      if (gift) payload.attributes[GIFT_ORDER_KEY] = gift.checked ? 'כן' : '';
      if (note) payload.note = note.value;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
        body: JSON.stringify(payload)
      }).then(function(response){
        if (!response.ok) throw new Error('Cart fields could not be saved');
        return response.json();
      });
    });
    return fieldsQueue;
  }

  /* ─ Add-to-cart errors ─
     /cart/add.js מחזיר 422 עם description בעברית כשההוספה נדחית — רובן ככולן סיבות
     מלאי, ובבאנדל נייטיבי גם כשרכיב אחד אזל בעוד המארז עצמו נראה זמין. בלי הצגה
     הכפתור פשוט מתאפס והלקוח מסיק שהלחיצה לא נקלטה. מציגים את הנוסח של שופיפיי כי
     הוא מסביר בדיוק מה נדחה; T.addError הוא נפילה לאחור לשגיאת רשת בלבד. */
  function formError(form, msg) {
    // בעמוד המוצר יש את מעטפת השגיאה של Dawn — משתמשים בה כדי לא לייצר סגנון שני.
    var wrap = form.querySelector('.product-form__error-message-wrapper');
    if (wrap) {
      var span = wrap.querySelector('.product-form__error-message');
      if (span) span.textContent = msg;
      wrap.removeAttribute('hidden');
      return;
    }
    // אפסייל והוספה מהירה — אין להם מעטפת, לכן שורה משלנו מתחת לכפתור.
    var note = form.querySelector('.jonis-add-error');
    if (!note) {
      note = document.createElement('p');
      note.className = 'jonis-add-error';
      note.setAttribute('role', 'alert');
      var target = form.querySelector('[name="add"],[type="submit"]');
      (target && target.parentNode ? target.parentNode : form).appendChild(note);
    }
    note.textContent = msg;
    note.classList.add('is-visible');
  }

  function clearFormError(form) {
    var wrap = form.querySelector('.product-form__error-message-wrapper');
    if (wrap) wrap.setAttribute('hidden', '');
    var note = form.querySelector('.jonis-add-error');
    if (note) note.classList.remove('is-visible');
  }

  /* ─ Add-to-cart forms ─ */
  function bindForms(root) {
    root.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
      if (form.dataset.jonisBound) return;
      form.dataset.jonisBound = '1';
      form.addEventListener('submit', function(e){
        e.preventDefault();
        clearFormError(form);
        var btn = form.querySelector('[name="add"],[type="submit"]');
        if (btn) btn.disabled = true;
        fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'X-Requested-With':'XMLHttpRequest'}})
          .then(function(r){return r.json();})
          .then(function(d){
            if (d.status) { formError(form, d.description || d.message || T.addError); return; }
            openDrawer();
            refreshCart();
          })
          .catch(function(e){console.error(e);formError(form, T.addError);})
          .finally(function(){if(btn)btn.disabled=false;});
      });
    });
  }

  /* ─ Open / Close ─ */
  function openDrawer() {
    if (!drawer || !overlay) return;
    if (isCartPage) {
      refreshCart();
      var heading = document.getElementById('jonis-cart-page-title');
      if (heading) heading.focus();
      return;
    }
    if (!isOpen) { lastFocusedElement = document.activeElement; pendingView = true; }
    isOpen = true;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    var closeBtn = document.getElementById('jonis-cart-close');
    if (closeBtn) closeBtn.focus();
    showLoading();
    refreshCart();
    loadUpsells();
  }

  function closeDrawer() {
    if (!drawer || !overlay || isCartPage) return;
    var returnFocus = lastFocusedElement && document.contains(lastFocusedElement)
      ? lastFocusedElement
      : document.querySelector('[data-open-cart-drawer]');
    isOpen = false;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
    lastFocusedElement = null;
    if (returnFocus) returnFocus.focus();
  }

  function showLoading() {
    if (itemsEl) itemsEl.innerHTML = '<div class="jonis-cart-drawer__loading"><div class="jonis-cart-spinner"></div></div>';
    if (emptyEl)  emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'none';
    if (upsellSection) upsellSection.style.display = 'none';
  }

  /* ─ Cart fetch & render ─ */
  function refreshCart() {
    return fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        cartState = cart;
        renderCart(cart);
        updateShippingBar(cart.total_price);
        syncCount(cart.item_count);
        prefillNote(cart.note);
        prefillGreeting(cart.attributes);
        prefillGiftOrder(cart.attributes);
        return cart;
      });
  }

  function renderCart(cart) {
    syncCartExtras();
    if (window.JonisTermsConsent) window.JonisTermsConsent.updateCart(cart);
    if (!itemsEl||!emptyEl) return;
    if (!cart.item_count) {
      itemsEl.innerHTML='';
      emptyEl.style.display='flex';
      if(upsellSection) upsellSection.style.display='none';
      if(controlsEl) controlsEl.style.display='none';
      if(footerEl) footerEl.style.display='none';
      return;
    }
    emptyEl.style.display='none';
    if(upsellSection) upsellSection.style.display='block';
    if(controlsEl) controlsEl.style.display='flex';
    if(footerEl) footerEl.style.display='flex';
    itemsEl.innerHTML = cart.items.map(itemHTML).join('');
    if(totalEl) totalEl.textContent = fmt(cart.total_price);

    itemsEl.querySelectorAll('[data-jonis-qty]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var key=btn.dataset.key;
        var item=cartState&&cartState.items.find(function(i){return i.key===key;});
        if(!item) return;
        changeQty(key, item.quantity+parseInt(btn.dataset.delta,10));
      });
    });
    itemsEl.querySelectorAll('[data-jonis-remove]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var key=btn.dataset.key;
        var row=itemsEl.querySelector('[data-item-key="'+key+'"]');
        if(row){row.classList.add('is-removing');setTimeout(function(){changeQty(key,0);},360);}
        else changeQty(key,0);
      });
    });
  }

  function syncCartExtras() {
    if (!drawer || !drawer.dataset.sectionId) return;
    var revision = ++extrasRevision;
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', drawer.dataset.sectionId);
    fetch(url.pathname + url.search, {headers: {'X-Requested-With': 'XMLHttpRequest'}})
      .then(function(response) { if (!response.ok) throw new Error('Cart section unavailable'); return response.text(); })
      .then(function(html) {
        if (revision !== extrasRevision) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var payload = doc.querySelector('jonis-cart-view');
        var view = document.querySelector('jonis-cart-view');
        if (payload && view) {
          view.setAttribute('view-event-payload', payload.getAttribute('view-event-payload'));
          if (pendingView && isOpen && typeof view.dispatchViewEvent === 'function') {
            view.dispatchViewEvent(); pendingView = false;
          }
        }
        var templates = doc.getElementById('jonis-cart-disclosures');
        if (!templates || !itemsEl) return;
        var rows = Array.from(itemsEl.querySelectorAll('[data-item-key]'));
        templates.content.querySelectorAll('template[data-line-key]').forEach(function(template) {
          var row = rows.find(function(item) { return item.dataset.itemKey === template.dataset.lineKey; });
          if (!row || !template.content.querySelector('.cart-item__disclosure')) return;
          row.querySelectorAll('[data-jonis-disclosure]').forEach(function(old) { old.remove(); });
          var wrap = document.createElement('div');
          wrap.dataset.jonisDisclosure = '';
          wrap.appendChild(template.content.cloneNode(true));
          var title = row.querySelector('.jonis-cart-item__title');
          if (title) title.after(wrap);
        });
      })
      .catch(function(error) { console.error('[JONIS] Cart details refresh failed', error); });
  }

  function itemHTML(item) {
    var heartImages = {"54254677361008": {"תכלת": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-together-ribbon-blue.png?v=1792358350", "ורוד": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-together-ribbon-pink.png?v=1792358401", "לבן": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-together-ribbon-white.png?v=1792358409"}, "53539660497264": {"תכלת": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-first-spark-cactus-red-ribbon-blue.png?v=1792358420", "ורוד": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-first-spark-cactus-red-ribbon-pink.png?v=1792358428", "לבן": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-first-spark-cactus-red-ribbon-white.png?v=1792358435"}, "53868743950704": {"תכלת": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-ever-after-ribbon-blue.png?v=1792358443", "ורוד": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-ever-after-ribbon-pink.png?v=1792358456", "לבן": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-ever-after-ribbon-white.png?v=1792358463"}, "53539660464496": {"תכלת": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-first-spark-cactus-yellow-ribbon-blue.png?v=1792358470", "ורוד": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-first-spark-cactus-yellow-ribbon-pink.png?v=1792358484", "לבן": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-first-spark-cactus-yellow-ribbon-white.png?v=1792358491"}, "53868743098736": {"תכלת": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-first-spark-cactus-orange-ribbon-blue.png?v=1792358498", "ורוד": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-first-spark-cactus-orange-ribbon-pink.png?v=1792358506", "לבן": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-first-spark-cactus-orange-ribbon-white.png?v=1792358514"}, "53539660530032": {"תכלת": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-first-spark-cactus-pink-ribbon-blue.png?v=1792358523", "ורוד": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-first-spark-cactus-pink-ribbon-pink.png?v=1792358532", "לבן": "https://cdn.shopify.com/s/files/1/0995/1408/9840/files/jonis-first-spark-cactus-pink-ribbon-white.png?v=1792358539"}};
    var ribbon = item.properties && item.properties['צבע הסרט'];
    var imageUrl = heartImages[String(item.variant_id)]?.[ribbon || 'תכלת'] || item.image;
    var ribbonHtml = ribbon ? '<p class="jonis-cart-item__variant">צבע הסרט: '+esc(ribbon)+'</p>' : '';
    var img = imageUrl
      ? '<img class="jonis-cart-item__image" src="'+esc(imageUrl)+'" alt="'+esc(item.product_title)+'" width="80" height="80" loading="lazy">'
      : '<div class="jonis-cart-item__image-placeholder">🌵</div>';
    var variant = (item.variant_title&&item.variant_title!=='Default Title')
      ? '<p class="jonis-cart-item__variant">'+esc(item.variant_title)+'</p>' : '';
    var orig = (item.original_price>item.final_price)
      ? '<span class="jonis-cart-item__original-price">'+fmt(item.original_price*item.quantity)+'</span>' : '';
    return '<div class="jonis-cart-item" data-item-key="'+esc(item.key)+'">'
      +img
      +'<div class="jonis-cart-item__info">'
        +'<h4 class="jonis-cart-item__title">'+esc(item.product_title)+'</h4>'
        +variant+ribbonHtml
        +'<div class="jonis-cart-item__qty-row">'
          +'<div class="jonis-cart-item__qty-control">'
            +'<button class="jonis-cart-item__qty-btn" data-jonis-qty data-key="'+esc(item.key)+'" data-delta="-1" type="button" aria-label="הפחת כמות">−</button>'
            +'<span class="jonis-cart-item__qty-num">'+item.quantity+'</span>'
            +'<button class="jonis-cart-item__qty-btn" data-jonis-qty data-key="'+esc(item.key)+'" data-delta="1" type="button" aria-label="הוסף כמות">+</button>'
          +'</div>'
          +'<button class="jonis-cart-item__remove" data-jonis-remove data-key="'+esc(item.key)+'" type="button" aria-label="הסר מוצר">'
            +'<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11 3L3 11M3 3L11 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
          +'</button>'
        +'</div>'
      +'</div>'
      +'<div class="jonis-cart-item__price-col">'+orig+'<span class="jonis-cart-item__price">'+fmt(item.final_line_price)+'</span></div>'
      +'</div>';
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify({id:key,quantity:Math.max(0,qty)})
    }).then(function(r){return r.json();}).then(function(cart){
      if (cart.errors || cart.status >= 400) throw new Error(cart.description || cart.errors || T.addError);
      return refreshCart();
    }).catch(function(error){
      console.error(error);
      return refreshCart();
    });
  }

  /* ─ Free shipping bar + gap closer ─
     Stating the gap is not enough — naming the specific product that closes it turns a
     generic cross-sell into a problem the shopper already wants to solve. */
  function updateShippingBar(total) {
    if(!shippingFill||!shippingText) return;
    shippingFill.style.width = Math.min((total/THRESHOLD)*100,100)+'%';
    var r = THRESHOLD-total;
    if (r<=0) {
      shippingText.innerHTML = '<span class="jonis-cart-drawer__shipping-success-line"><span class="jonis-cart-drawer__shipping-check" aria-hidden="true">✓</span>'+esc(T.shipSuccess)+'</span><small class="jonis-cart-drawer__shipping-success-note">'+esc(T.shipSuccessNote)+'</small>';
      if (shippingBar) shippingBar.classList.add('is-complete');
      hideSuggest();
    } else {
      shippingText.innerHTML = fill(T.shipProgress, '[סכום]', '<strong>'+fmt(r)+'</strong>');
      if (shippingBar) shippingBar.classList.remove('is-complete');
      renderSuggest(r);
    }
  }

  /* Cheapest AVAILABLE upsell variant whose price actually reaches the gap.
     Deliberately skips anything already in the cart, and skips variants that would
     still leave the shopper short — suggesting those is worse than suggesting nothing. */
  function findGapCloser(remainingCents) {
    if (!upsellProducts.length || remainingCents <= 0) return null;
    var inCart = {};
    if (cartState && cartState.items) {
      cartState.items.forEach(function(i){ inCart[i.variant_id] = true; });
    }
    var best = null;
    upsellProducts.forEach(function(p){
      (p.variants || []).forEach(function(v){
        if (!v.available) return;
        if (inCart[v.id]) return;
        var priceCents = Math.round(parseFloat(v.price) * 100);
        if (!priceCents || priceCents < remainingCents) return;
        if (!best || priceCents < best.priceCents) {
          best = { product: p, variant: v, priceCents: priceCents };
        }
      });
    });
    return best;
  }

  function renderSuggest(remaining) {
    if (!suggestBtn || !suggestText) return;
    var hit = findGapCloser(remaining);
    if (!hit) { hideSuggest(); return; }
    var name = hit.product.title;
    if (hit.variant.title && hit.variant.title !== 'Default Title') {
      name += ' · ' + hit.variant.title;
    }
    suggestBtn.dataset.variantId = hit.variant.id;
    var html = fill(T.shipSuggest, '[מוצר]', '<strong>' + esc(name) + '</strong>');
    html = fill(html, '[מחיר]', fmt(hit.priceCents));
    suggestText.innerHTML = html;
    suggestBtn.hidden = false;
  }

  function hideSuggest() {
    if (suggestBtn) { suggestBtn.hidden = true; suggestBtn.dataset.variantId = ''; }
  }

  function addSuggested() {
    if (!suggestBtn) return;
    var vid = parseInt(suggestBtn.dataset.variantId, 10);
    if (!vid) return;
    suggestBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(function(r){ return r.json(); })
      .then(function(res){
        if (res.status && res.status >= 400) throw new Error(res.description || 'שגיאה');
        refreshCart();
      })
      .catch(function(err){ console.error(err); })
      .finally(function(){ suggestBtn.disabled = false; });
  }

  function syncCount(n) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (!bubble && n > 0) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      icon.appendChild(bubble);
    }
    if (!bubble) return;
    var count = bubble.querySelector('[aria-hidden]');
    if (!count) {
      count = document.createElement('span');
      count.setAttribute('aria-hidden', 'true');
      bubble.appendChild(count);
    }
    var accessibleCount = bubble.querySelector('.visually-hidden');
    if (!accessibleCount) {
      accessibleCount = document.createElement('span');
      accessibleCount.className = 'visually-hidden';
      bubble.appendChild(accessibleCount);
    }
    count.textContent = String(n);
    count.style.display = n < 100 ? '' : 'none';
    accessibleCount.textContent = String(n);
    bubble.style.display = n > 0 ? '' : 'none';
  }

  /* ─ Upsell Carousel ─ */
  function variantImageUrl(p, variant) {
    if (variant && variant.featured_image) {
      if (typeof variant.featured_image === 'string') return variant.featured_image;
      if (variant.featured_image.src) return variant.featured_image.src;
    }
    var images = p.images || [];
    if (variant) {
      for (var i = 0; i < images.length; i++) {
        var ids = images[i].variant_ids || [];
        for (var j = 0; j < ids.length; j++) {
          if (String(ids[j]) === String(variant.id)) return images[i].src;
        }
      }
    }
    return images.length ? images[0].src : '';
  }

  function shortProductText(html, limit) {
    var box = document.createElement('div');
    box.innerHTML = html || '';
    var text = (box.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    var words = text.split(' ');
    if (words.length <= limit) return text;
    var sentences = text.match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [text];
    var picked = [];
    var wordCount = 0;
    sentences.forEach(function(sentence){
      if (wordCount >= limit) return;
      var clean = sentence.trim();
      if (!clean) return;
      picked.push(clean);
      wordCount += clean.split(/\s+/).length;
    });
    return picked.join(' ').trim();
  }

  function isMatchesProduct(p) { return /גפרור/.test(p.title || '') || /matches/.test(p.handle || ''); }

  function setCardImage(card, src, alt) {
    var image = card && card.querySelector('[data-upsell-image]');
    if (!image || !src || image.src === src) return;
    image.classList.add('is-changing');
    image.onload = function () { image.classList.remove('is-changing'); image.onload = null; };
    image.src = src;
    if (alt) image.alt = alt;
  }

  function upsellCardHTML(p) {
    var variants = p.variants || [];
    var availableVariants = variants.filter(function(v){ return v.available; });
    var defaultVariant = availableVariants[0] || variants[0];
    if (p.handle === 'natural-car-diffuser-ceramic') {
      var diffuserDefault = availableVariants.filter(function(v){ return /שלווה שמימית/.test(v.title || ''); })[0];
      if (diffuserDefault) defaultVariant = diffuserDefault;
    }
    var defaultImage = variantImageUrl(p, defaultVariant);
    var img = defaultImage
      ? '<img class="jonis-upsell-card__image" data-upsell-image src="'+esc(defaultImage)+'" alt="'+esc(p.title + (defaultVariant && defaultVariant.title !== 'Default Title' ? ' · ' + defaultVariant.title : ''))+'" loading="lazy">'
      : '<div class="jonis-upsell-card__image" style="background:#F8F5F0;display:flex;align-items:center;justify-content:center;font-size:2rem;aspect-ratio:1;">🌵</div>';
    var isMatches = isMatchesProduct(p);
    var badge = isMatches ? T.matchesBadge : T.kishoritBadge;
    var origin = isMatches ? T.matchesOrigin : T.kishoritOrigin;
    var desc = shortProductText(p.body_html, 32) || origin;
    var modalId = 'jonis-upsell-details-' + p.id;
    var detailsHTML = '<button type="button" class="jonis-upsell-card__more" aria-expanded="false" aria-haspopup="dialog" aria-controls="'+modalId+'">'+esc(T.upsellMore)+'</button>' +
      '<div id="'+modalId+'" class="jonis-upsell-card__details" role="dialog" aria-modal="true" aria-labelledby="'+modalId+'-title" hidden>' +
      '<button type="button" class="jonis-upsell-card__details-backdrop" aria-label="סגור פרטים"></button><div class="jonis-upsell-card__details-dialog" tabindex="-1">' +
      '<button type="button" class="jonis-upsell-card__details-close" aria-label="סגור פרטים">×</button><span class="jonis-upsell-card__details-origin">'+esc(origin)+'</span>' +
      '<h4 id="'+modalId+'-title" class="jonis-upsell-card__details-title">'+esc(p.title)+'</h4><div class="jonis-upsell-card__details-body" data-jud-default>'+esc(desc)+'</div></div></div>';
    var priceSource = defaultVariant || variants[0];
    var priceHTML = priceSource ? '<span class="jonis-upsell-card__price" data-upsell-price>'+fmt(Math.round(parseFloat(priceSource.price)*100))+'</span>' : '';
    var controlsHTML;
    if (!defaultVariant || !defaultVariant.available) { controlsHTML = '<span class="jonis-cart-drawer-upsell-soldout">'+esc(T.upsellSoldout)+'</span>'; }
    else {
      var selectHTML = '';
      if (variants.length > 1) {
        var options = variants.map(function(v){
          var imageUrl=variantImageUrl(p,v); var alt=p.title+(v.title!=='Default Title'?' · '+v.title:'');
          return '<option value="'+v.id+'" data-price="'+v.price+'" data-image="'+esc(imageUrl)+'" data-alt="'+esc(alt)+'"'+(!v.available?' disabled':'')+(v.id===defaultVariant.id?' selected':'')+'>'+esc(v.title)+'</option>';
        }).join('');
        selectHTML='<select class="jonis-cart-drawer-upsell-select">'+options+'</select>';
      }
      controlsHTML=selectHTML+'<label class="jonis-cart-drawer-upsell-toggle"><input type="checkbox" class="jonis-cart-drawer-upsell-cb" data-variant-id="'+defaultVariant.id+'"><span class="jonis-cart-drawer-upsell-toggle-track" aria-hidden="true"></span><span class="jonis-cart-drawer-upsell-toggle-label">'+esc(T.upsellAdd)+'</span></label>';
    }
    return '<div class="jonis-upsell-card"><a href="/products/'+esc(p.handle)+'" class="jonis-upsell-card__img-link">'+img+'</a><span class="jonis-upsell-card__origin-badge">'+esc(badge)+'</span><a href="/products/'+esc(p.handle)+'" class="jonis-upsell-card__title">'+esc(p.title)+'</a>'+priceHTML+detailsHTML+controlsHTML+'</div>';
  }

  function loadUpsells() {
    if(!upsellTrack) return;
    fetch('/collections/'+UPSELL_HANDLE+'/products.json?limit='+UPSELL_LIMIT,
      {headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){return r.json();})
      .then(function(data){
        if(!data.products||!data.products.length){
          var hasLiquidCards = upsellTrack.querySelector('.jonis-upsell-card');
          if(hasLiquidCards){
            if(upsellSection) upsellSection.style.display='block';
            bindUpsellControls();
          } else if(upsellSection) {
            upsellSection.style.display='none';
          }
          upsellProducts = [];
          hideSuggest();
          return;
        }
        upsellProducts = data.products.slice(0, UPSELL_LIMIT).sort(function(a, b){
          return Number(isMatchesProduct(a)) - Number(isMatchesProduct(b));
        });
        /* Keep the server-rendered cards when they exist. The Liquid markup in
           snippets/cart-drawer.liquid is richer than upsellCardHTML — it emits a separate
           description body per variant (data-jud-variant) that this renderer does not — so
           replacing it silently downgrades the details panel to one generic description.
           The fetch is still needed for upsellProducts, which is what the free-shipping
           gap closer reads. */
        if (!upsellTrack.querySelector('.jonis-upsell-card')) {
          upsellTrack.innerHTML = upsellProducts.map(upsellCardHTML).join('');
        }
        bindUpsellControls();
        /* the shipping bar may have rendered before we knew the catalogue — re-run it now */
        if (cartState) updateShippingBar(cartState.total_price);
      })
      .catch(function(){
        var hasLiquidCards = upsellTrack.querySelector('.jonis-upsell-card');
        if(hasLiquidCards){
          if(upsellSection) upsellSection.style.display='block';
          bindUpsellControls();
        } else if(upsellSection) {
          upsellSection.style.display='none';
        }
        upsellProducts = [];
        hideSuggest();
      });
  }

  function setToggleLabel(cb, text) {
    var card = cb.closest('.jonis-upsell-card');
    var lbl = card && card.querySelector('.jonis-cart-drawer-upsell-toggle-label');
    if (lbl) lbl.textContent = text;
  }

  function bindUpsellControls() {
    if (!upsellTrack) return;

    upsellTrack.querySelectorAll('.jonis-cart-drawer-upsell-select').forEach(function(sel){
      if (sel.dataset.jonisBound) return;
      sel.dataset.jonisBound = '1';
      sel.addEventListener('change', function(){
        var opt = sel.options[sel.selectedIndex];
        var card = sel.closest('.jonis-upsell-card');
        if (!card) return;
        var cb = card.querySelector('.jonis-cart-drawer-upsell-cb');
        var priceEl = card.querySelector('[data-upsell-price]');
        setCardImage(card, opt.dataset.image, opt.dataset.alt);
        if (cb) {
          /* switching variant while toggled on would add the wrong line; require re-toggling */
          if (cb.checked) { cb.checked = false; cb.dataset.lineKey = ''; setToggleLabel(cb, T.upsellAdd); }
          cb.dataset.variantId = opt.value;
        }
        if (priceEl && opt.dataset.price) priceEl.textContent = fmt(Math.round(parseFloat(opt.dataset.price) * 100));
      });
    });

    upsellTrack.querySelectorAll('.jonis-cart-drawer-upsell-cb').forEach(function(cb){
      if (cb.dataset.jonisBound) return;
      cb.dataset.jonisBound = '1';
      cb.addEventListener('change', function(){
        var vid = parseInt(cb.dataset.variantId, 10);
        if (!vid) return;
        cb.disabled = true;

        if (cb.checked) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
            body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
          })
          .then(function(r){ return r.json(); })
          .then(function(res){
            if (res.status && res.status >= 400) throw new Error(res.description || 'שגיאה');
            var addedLine = res && res.items && res.items[0] ? res.items[0] : res;
            if (!addedLine || !addedLine.key) throw new Error('Missing added line key');
            cb.dataset.lineKey = addedLine.key;
            setToggleLabel(cb, T.upsellAdded);
            refreshCart();
          })
          .catch(function(err){
            console.error(err);
            cb.checked = false;
          })
          .finally(function(){ cb.disabled = false; });
        } else {
          var key = cb.dataset.lineKey;
          if (!key || key === 'undefined' || key === 'null') { cb.checked = true; cb.disabled = false; return; }
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
            body: JSON.stringify({ id: key, quantity: 0 })
          })
          .then(function(r){ return r.json(); })
          .then(function(cart){
            if (cart.errors || cart.status >= 400) throw new Error(cart.description || cart.errors || T.addError);
            cb.dataset.lineKey = '';
            setToggleLabel(cb, T.upsellAdd);
            return refreshCart();
          })
          .catch(function(err){
            console.error(err);
            cb.checked = true;
          })
          .finally(function(){ cb.disabled = false; });
        }
      });
    });
  }

  /* ─ Note ─ */
  function saveNote(note) {
    saveCartFields().catch(function(error){ console.error(error); });
  }
  function prefillNote(note) {
    var ta=document.getElementById('jonis-cart-note');
    if(ta&&note&&!ta.dataset.prefilled){ta.value=note;ta.dataset.prefilled='1';}
  }

  /* ─ Discount ─
     GET /discount/CODE stores the code on the shopper's session; it then carries into
     checkout on its own — no formaction override needed, so the standard Shopify
     checkout form (which Sense RTL and friends hook) stays intact.
     We only say "applied" when /cart.js actually confirms a cart-level discount.
     Shipping- and product-level discounts don't surface there, so in that case we say
     what is true — the code is stored and checkout will verify it. We never fake a ✓. */
  function applyDiscount() {
    var input = document.getElementById('jonis-discount-input');
    var msg   = document.getElementById('jonis-discount-msg');
    var btn   = document.getElementById('jonis-discount-btn');
    if (!input || !msg) return;
    var code = input.value.trim();
    if (!code) return;

    if (btn) btn.disabled = true;
    msg.style.display = 'block';
    msg.className = 'jonis-cart-drawer__discount-msg neutral';
    msg.textContent = T.discountChecking;

    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function(){ return fetch('/cart.js', {headers:{'X-Requested-With':'XMLHttpRequest'}}); })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        cartState = cart;
        renderCart(cart);
        updateShippingBar(cart.total_price);
        syncCount(cart.item_count);

        var apps = cart.cart_level_discount_applications || [];
        var applied = apps.some(function(a){
          return String(a.title || '').toLowerCase() === code.toLowerCase();
        });

        if (applied) {
          msg.className = 'jonis-cart-drawer__discount-msg success';
          msg.textContent = T.discountSuccess;
        } else {
          msg.className = 'jonis-cart-drawer__discount-msg neutral';
          msg.textContent = T.discountPending;
        }
      })
      .catch(function(){
        msg.className = 'jonis-cart-drawer__discount-msg neutral';
        msg.textContent = T.discountPending;
      })
      .finally(function(){ if (btn) btn.disabled = false; });
  }

  /* ─ Boot ─ */
  window.jonisCartDrawerBoot = init;
  window.JonisCartDrawer = { open: openDrawer, close: closeDrawer, refresh: refreshCart };

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
  else{init();}
})();
